import JiraAttachmentItem from "./JiraAttachmentItem";

export default JiraAttachmentItem;
